import OverflowCarousel from './OverflowCarousel';

export * from './OverflowCarousel';
export default OverflowCarousel;
